import { environment } from "@env/environment";

export class ProductFamilyModel {
    QueryValue: string;
    FamilyId: string;
    FamilyName: string;
    Order: number;
    Active: number;
    CreatedBy: string;
    Company: string;
    Action: string;
    Selected:boolean;
    Origin: number;
    Language: string;

    constructor() {
        this.QueryValue = '';
        this.FamilyId = '';
        this.FamilyName = '';
        this.Order = 0;
        this.Active = 0;
        this.CreatedBy = '';
        this.Company = '';
        this.Action = '';
        this.Selected=false;
        this.Origin = 1;
        this.Language = '';
    }
  }
